import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { getCharges, GetChargesRequest } from 'api/admin/charges/getCharges'
import { chargesKeys } from './keys'

export const useChargesQuery = (
  request: GetChargesRequest,
  options?: { enabled?: boolean }
) => {
  const hasIdentityFilter =
    request.companyId != null ||
    request.shiftId != null ||
    request.workerId != null ||
    request.invoiceId != null

  return useQuery({
    queryKey: chargesKeys.list([
      request.page,
      request.pageSize,
      request.companyId ?? 'all',
      request.shiftId ?? 'all',
      request.workerId ?? 'all',
      request.invoiceId ?? 'all',
      request.invoiced ?? 'all',
    ]),
    queryFn: () => getCharges(request),
    placeholderData: keepPreviousData,
    enabled: (options?.enabled ?? true) && hasIdentityFilter,
  })
}
